import config from "config";
import { APICore } from "helpers/api/apiCore";
import { AuditTrailReportPayload } from "./types";

const api = new APICore();

function createAuditTrailReportApi(params: AuditTrailReportPayload) {
  const apiData = {
    startDate: params.startDate,
    endDate: params.endDate,
    module: params.module || null,
    user: params.user || null,
    actionType: params.actionType || null,
    saveReport: params.saveReport ?? false
  };

  const backendApiUrl = `${config.BACKEND_BASE_URL}/report/audit-trail-report`;
  return api.create(backendApiUrl, apiData);
}

export { createAuditTrailReportApi };
